export const emailTypes = ['officeEmail', 'privateEmail'];

export const phoneTypes = ['homePhone', 'mobilePhone1', 'mobilePhone2', 'workPhone'];
